/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m27.2539 4.4989c2.985 2.952 4.669 6.937 4.744 11.221.152 8.818-7.016 16.12-15.981 16.277-.096.001-.19.002-.285.002-8.69 0-15.575-6.852-15.729-15.723-.075-4.26 1.569-8.309 4.626-11.401 3.037-3.069 7.069-4.799 11.353-4.873 4.271-.063 8.265 1.522 11.272 4.497zm-11.2544 14.5429c.553 0 1-.448 1-1v-9.544c0-.552-.447-1-1-1s-1 .448-1 1v9.544c0 .552.447 1 1 1zm0 2.0903c-.928 0-1.682.754-1.682 1.682 0 .927.754 1.681 1.682 1.681s1.682-.754 1.682-1.681c0-.928-.754-1.682-1.682-1.682z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;